<div class="alert alert-danger" *ngIf="errors?.length > 0">
    <div *ngFor="let error of errors">
        {{error}}
    </div>
</div>